<template>
  <v-card
    outlined
    class='mb-5 px-3 pb-3'
    style="max-width: 380px;"
  >
    <v-select
      v-model="regulationBundlerId"
      :items="regulationBundlers"
      item-text="name"
      item-value="id"
      class='mt-3'
    >
      <template v-slot:label>
        <InputLabel label-name="レギュレーション" />
      </template>
    </v-select>
    <div style='display: flex; justify-content: space-between;'>
      <InputLabel label-name="ランクキーワード" />
      <v-btn icon small @click="showDetail = !showDetail">
        <v-icon>{{
          showDetail ? 'mdi-chevron-up' : 'mdi-chevron-down'
        }}</v-icon>
      </v-btn>
    </div>
    <div v-if="showDetail">
      <v-card
        v-for="(keywords, rankName) in rankKeywords"
        :key="rankName"
        elevation="0"
        tile
        outlined
        class="mt-2"
      >
        <v-card-title class="text-subtitle-2 pa-3 pb-2">
          {{ rankName.toUpperCase() }} ランク
        </v-card-title>
        <v-card-text class="pa-3 pt-0">
          <template v-if="keywords">
            <div style='display: flex; gap: 10px 6px; flex-wrap: wrap;'>
              <v-text-field
                v-for="(keyword, index) in keywords"
                :key="index"
                :value="keyword"
                append-icon="mdi-close"
                required
                dense
                style='max-width: 31%; font-size: 11px;'
                class='post-rankKeywords-textField'
                hide-details="auto"
                @click:append="deleteKeyword(index, rankName)"
                @input="(val) => updateKeyword(val, index, rankName)"
              />
            <v-btn
              small
              depressed
              outlined
              class='mt-1 ml-1'
              color="primary"
              @click="addKeyword(rankName)"
            >
              <v-icon left small> mdi-plus </v-icon>
              追加
            </v-btn>
            </div>
          </template>
        </v-card-text>
      </v-card>
    </div>
  </v-card>
</template>

<script>
import axios from 'axios'
import { deserialize } from 'deserialize-json-api'
import { mapState } from 'vuex'
import InputLabel from '@/components/commons/formParts/inputLabel'

export default {
  components: { InputLabel },
  data: () => {
    return {
      selectedRegulationBundlerId: '',
      regulationBundlers: [],
      rankKeywords: {
        'a': [],
        'b': [],
        'c': [],
        'd': []
      },
      showDetail: false
    }
  },
  mounted () {
    axios.get('/api/regulation_bundlers').then(({ data }) => {
      this.regulationBundlers = deserialize(data).data
    })
    if (this.post.rankKeywords) {
      this.rankKeywords = this.post.rankKeywords
    }
  },
  computed: {
    ...mapState({
      post: (state) => state.PostEditor.post
    }),
    regulationBundlerId: {
      get () {
        return this.post.regulationBundlerId
      },
      set (regulationBundlerId) {
        this.$store.commit('PostEditor/UPDATE_REGULATION_BUNDLER', regulationBundlerId)
      }
    }
  },
  methods: {
    addKeyword (rankName) {
      this.rankKeywords[rankName].push('')
      this.$store.commit('PostEditor/UPDATE_RANK_KEYWORDS', this.rankKeywords)
    },
    updateKeyword (val, index, rankName) {
      this.rankKeywords[rankName][index] = val
      this.$store.commit('PostEditor/UPDATE_RANK_KEYWORDS', this.rankKeywords)
    },
    deleteKeyword (index, rankName) {
      this.rankKeywords[rankName].splice(index, 1)
      this.$store.commit('PostEditor/UPDATE_RANK_KEYWORDS', this.rankKeywords)
    }
  }
}
</script>

<style>
  .post-rankKeywords-textField .v-input__append-inner {
    width: fit-content;
  }
  .post-rankKeywords-textField .v-input__icon {
    min-width: 10px;
    width: fit-content;
  }
  .post-rankKeywords-textField .v-input__icon button {
    width: 10px;
    font-size: 15px;
  }
</style>
